import io from "socket.io-client";

const getStoredAccessToken = () => {
  try {
    return sessionStorage.getItem("accessToken") || null;
  } catch (error) {
    return null;
  }
};

// Token sent in the most recent handshake, used to skip needless reconnects.
let handshakeToken = getStoredAccessToken();

// `auth` is a callback so every connect and automatic reconnect reads the latest token.
// Sockets without a token still connect; the backend only uses the token to join the user's private room.
export const socket = io.connect(process.env.REACT_APP_SOCKET_URL, {
  auth: (cb) => {
    handshakeToken = getStoredAccessToken();
    cb(handshakeToken ? { token: handshakeToken } : {});
  },
});

// Called whenever the session token is set or cleared.
// Listeners registered with socket.on stay attached across disconnect/connect.
export const updateSocketAccessToken = (accessToken) => {
  const isSocketActive = socket.connected || socket.active;

  if (!accessToken) {
    handshakeToken = null;
    if (isSocketActive) {
      socket.disconnect();
    }
    return;
  }

  if (accessToken === handshakeToken && isSocketActive) {
    return;
  }

  if (isSocketActive) {
    socket.disconnect();
  }
  socket.connect();
};
